import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import SEO from '../components/SEO';

const FAQS = [
  {
    question: "What services do you offer?",
    answer: "We offer full-cycle custom web development, mobile app development (iOS & Android), and UI/UX design. We specialize in building scalable, modern, and high-performance digital products for startups and enterprises."
  },
  {
    question: "How long does it take to build a website?",
    answer: "A standard corporate website takes about 3-4 weeks. More complex web applications or e-commerce platforms can take anywhere from 6 to 12 weeks depending on the features required."
  },
  {
    question: "Do you provide ongoing support?",
    answer: "Yes! We offer post-launch support and maintenance packages. We ensure your website remains up-to-date, secure, and fully optimized."
  },
  {
    question: "Will my website be mobile-friendly and SEO optimized?",
    answer: "Absolutely. All our websites are built with a mobile-first approach and include technical on-page SEO best practices straight out of the box."
  },
  {
    question: "What is your pricing structure?",
    answer: "Our pricing depends on the project scope, complexity, and timeline. We offer fixed-price contracts for well-defined projects."
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      <SEO title="FAQ | CodeViora" description="Frequently Asked Questions about our web and app development services." />
      
      {/* Hero */}
      <section class="bg-grid-black pt-16 pb-16 md:pt-20 md:pb-20 relative overflow-hidden border-white/10 rounded-b-[50px] md:rounded-b-[100px]">
        <div className="container-max relative text-center">
          <div className="max-w-3xl mx-auto animate-fade-up">
            <span className="section-label-inv">Support</span>
            <h1 className="section-title-inv text-5xl md:text-6xl mt-2">FREQUENTLY ASKED QUESTIONS.</h1>
            <p className="section-sub-inv text-lg mx-auto">Find answers to common questions about our process, pricing, and services.</p>
          </div>
        </div>
      </section>

      <section className="bg-grid-white py-20 min-h-[50vh]">
        <div className="max-w-3xl mx-auto px-5 md:px-0">
          <div className="space-y-4">
            {FAQS.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div 
                  key={index} 
                  className={`border rounded-2xl transition-all duration-300 overflow-hidden ${isOpen ? 'border-[#ff6b2b] bg-black/5 dark:bg-white/5' : 'border-black/10 dark:border-white/10 dark:border-white/10 bg-white dark:bg-[#111]'}`}
                >
                  <button
                    className="w-full px-6 py-5 text-left flex items-center justify-between gap-4"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  >
                    <span className="font-medium text-black dark:text-white text-lg">{faq.question}</span>
                    <div className={`w-8 h-8 flex-shrink-0 rounded-full flex items-center justify-center transition-transform duration-300 ${isOpen ? 'bg-[#ff6b2b] text-white rotate-180' : 'bg-black/5 dark:bg-white/5 dark:bg-white/10 text-black dark:text-white'}`}>
                      <ChevronDown size={18} />
                    </div>
                  </button>
                  
                  <div 
                    className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`}
                  >
                    <p className="text-black/70 dark:text-white/70 dark:text-white/70 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )
            })}
          </div>

          <div className="mt-16 text-center p-8 bg-black rounded-3xl text-white">
            <h3 className="text-2xl font-medium font-display mb-2 !text-white">Still have questions?</h3>
            <p className="text-white/70 mb-6">Can't find the answer you're looking for? Please chat to our friendly team.</p>
            <Link to="/contact" className="btn-primary-inv inline-flex">Get in touch</Link>
          </div>
        </div>
      </section>
    </>
  );
}
